// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3uXuR","col":"Table_col__2BByP","fulfillmentStatus":"Table_fulfillmentStatus__2FRbL","emailCol":"Table_emailCol__uVJu3"};